const PageHeader = ({
  eyebrow,
  showEyebrowDot = true,
  title,
  description,
  descriptionMaxWidth = 520,
  className = "",
}) => {
  return (
    <header className={`ph-root ${className}`.trim()}>
      <style>{`
        .ph-root { margin-bottom: var(--space-8); }
        .ph-eyebrow {
          font-family: var(--font-mono);
          font-size: 12px;
          color: var(--accent);
          letter-spacing: 0.1em;
          text-transform: uppercase;
          margin-bottom: var(--space-3);
          display: flex;
          align-items: center;
          gap: var(--space-2);
        }
        .ph-eyebrow-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: var(--accent);
          animation: ph-pulse 2s infinite;
          flex-shrink: 0;
        }
        @keyframes ph-pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.25; } }
        .ph-title {
          font-family: var(--font-display);
          font-size: clamp(32px, 5vw, 52px);
          font-weight: 400;
          line-height: 1.08;
          letter-spacing: -0.02em;
          color: var(--text-primary);
          margin-bottom: var(--space-3);
        }
        .ph-title em { font-style: italic; color: var(--accent); }
        .ph-description {
          font-size: 16px;
          color: var(--text-tertiary);
          line-height: 1.7;
          font-weight: 400;
        }
      `}</style>

      {eyebrow && (
        <div className="ph-eyebrow">
          {showEyebrowDot && <span className="ph-eyebrow-dot" aria-hidden="true" />}
          {eyebrow}
        </div>
      )}
      <h1 className="ph-title">{title}</h1>
      {description && (
        <p className="ph-description" style={{ maxWidth: descriptionMaxWidth }}>
          {description}
        </p>
      )}
    </header>
  );
};

export default PageHeader;
